export class SupplementalFormCategory {
  id: string;
  displayName: string;
}
